import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: `1px solid ${theme.palette.grey[100]}`,
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    backgroundColor: theme.palette.common.white,
    boxShadow: '0px 4px 8px rgba(0,0,0,0.12)',
    padding: theme.spacing(1),
  },
  showTabletAndDesktop: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  showDESKTOP: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}));
const WidgetSkeleton = () => {
  const classes = useStyles();

  return (
    <>
      <Grid className={classes.root} container spacing={1}>
        <Grid item lg={3} md={6} xs={12}>
          <Skeleton variant="rect" width="100%" height={50} />
        </Grid>
        <Grid item lg={3} md={6} xs={12} className={classes.showTabletAndDesktop}>
          <Skeleton variant="rect" width="100%" height={50} />
        </Grid>
        <Grid item lg={3} md={6} xs={12} className={classes.showDESKTOP}>
          <Skeleton variant="rect" width="100%" height={50} />
        </Grid>
        <Grid item lg={3} md={6} xs={12} className={classes.showDESKTOP}>
          <Skeleton variant="rect" width="100%" height={50} />
        </Grid>
      </Grid>
    </>
  );
};

export default WidgetSkeleton;
